import BordAnimationLoader from 'components/BordAnimationLoader/BordAnimationLoader';
import './QuoteLoaderModal.scss';

/** Modal de carga que bloquea la UI mientras se envía la cotización al cliente. */
const QuoteLoaderModal = () => {
  return (
    <div className="quoteLoaderModal">
      <div className="loaderContent">
        <p className="loaderText">Enviando la cotización...</p>
        <BordAnimationLoader width="14.3rem" />
      </div>
    </div>
  );
};

export default QuoteLoaderModal;
